import { render, staticRenderFns } from "./MaxLengthErrorMessage.vue?vue&type=template&id=e014d232&"
import script from "./MaxLengthErrorMessage.vue?vue&type=script&lang=js&"
export * from "./MaxLengthErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e014d232')) {
      api.createRecord('e014d232', component.options)
    } else {
      api.reload('e014d232', component.options)
    }
    module.hot.accept("./MaxLengthErrorMessage.vue?vue&type=template&id=e014d232&", function () {
      api.rerender('e014d232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Errors/MaxLengthErrorMessage.vue"
export default component.exports